import React from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Loading } from '@gull';
import Ticket from "../../../app/views/Pdf/Ticket"
import TicketSupplement from "../../../app/views/Pdf/TicketSupplement"
import useLoadPublicTicket from './useLoadPublicTicket';
import PublicDocumentNotFound from './PublicDocumentNotFound';
import PublicPdfPreview from './PublicPdfPreview';
import {computePublicTicketTotals} from './publicTicketTotals';

/**
 * Page publique de consultation d'un ticket B2C (sans authentification), affiche son PDF.
 */
const PublicVisualTicket = ({company,id,token}) => {
    const t = useTranslate();
    const [loading,ticketDetail,section,companyInfos,moduleInfos,pointsFidelite,error404] = useLoadPublicTicket(company, id, token)

    if(loading){
        return(
            <Loading></Loading>
        )
    }

    if(error404 || Object.keys(ticketDetail).length==0){
        return(<PublicDocumentNotFound />)
    }

    const {digit,totalAchat,tgcForTicketPdf,tgcTotal} = computePublicTicketTotals(ticketDetail.ticket_detail, companyInfos)

    const supplement_list_params = moduleInfos.params?.article?.params?.supplement_list
    const TicketComponent = supplement_list_params ? TicketSupplement : Ticket

    return(
        <PublicPdfPreview
            title="Aperçu du ticket"
            document={
                <TicketComponent
                    thisShop={section}
                    ticketPdf={ticketDetail}
                    t={t}
                    devise={companyInfos.devise}
                    digit={digit}
                    totalAchat={totalAchat}
                    tgcTotal={tgcTotal}
                    tgcForTicketPdf={tgcForTicketPdf}
                    pointsFidelite={pointsFidelite}
                    moduleParam={moduleInfos}
                    authParam={{company:companyInfos}}
                />
            }
        />
    )
}

export default PublicVisualTicket;
